import { defineMessages } from 'react-intl';

export default defineMessages({
  shipmentRecordSectionTitle: {
    defaultMessage: 'Shipment Record',
    description: 'Title for the shipment record section that shows info like weight and dimensions for a shipment',
    id: 'AVPux9',
  },
  sectionAriaLabel: {
    defaultMessage: 'Shipment Record expander section',
    description: 'Aria label for the expandable shipment record section',
    id: 'Prj16u',
  },
});
